import React, { KeyboardEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Text, Preset } from '@lux/text/tw';
import { trackSelectContent } from '@browsing/tracking';
import { useGRE } from '../../gre';

interface AllCampaignsCardProps {
    imageUrl: string;
}

const AllCampaignsCard = ({ imageUrl }: AllCampaignsCardProps) => {
    const { greTabData, greData } = useGRE();
    const navigate = useNavigate();

    const handleClick = () => {
        trackSelectContent('gre_carousel', 'click', { contentId: 'see_all_deals_last' });
        navigate(`/event/${greTabData.id}${window.location.search}`);
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLButtonElement>) => {
        if (e.currentTarget !== e.target) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <button
            type="button"
            className="relative flex h-full w-full items-center justify-center overflow-hidden"
            onClick={handleClick}
            onKeyDown={handleKeyDown}
        >
            <img
                className="absolute h-auto w-auto max-w-full"
                src={imageUrl}
                aria-hidden="true"
                alt=""
            />
            <span
                aria-hidden="true"
                className="absolute left-0 top-0 z-[1] h-full w-full bg-[rgba(0,0,0,0.5)]"
            />
            <Text
                preset={Preset.BUTTON}
                className="text-function-0 dark:text-function-100 z-[2] cursor-pointer active:scale-95 active:opacity-80"
            >
                {greData?.buttonText}
            </Text>
        </button>
    );
};

export default AllCampaignsCard;
